import AdminLayout from '@/components/feature/AdminLayout';
import { adminLogs } from '@/mocks/admin';

export default function AdminLogs() {
  return (
    <AdminLayout>
      <div className="max-w-5xl mx-auto">
        <h1 className="text-2xl font-bold text-foreground-950 mb-6">Nhật ký quản trị</h1>

        <div className="rounded-xl border border-background-200/60 overflow-hidden">
          <div className="bg-background-100 px-4 py-3 flex items-center justify-between border-b border-background-200/60">
            <p className="text-sm font-semibold text-foreground-950">Hoạt động gần đây</p>
            <p className="text-xs text-foreground-600">{adminLogs.length} bản ghi</p>
          </div>
          <div className="divide-y divide-background-200/40">
            {adminLogs.map((l) => (
              <div key={l.id} className="px-4 py-4 flex items-start gap-3 hover:bg-background-100/60 transition-colors">
                <div className="w-9 h-9 rounded-lg bg-accent-500/15 flex items-center justify-center shrink-0">
                  <i className="ri-history-line text-accent-400 text-lg"></i>
                </div>
                <div className="flex-1">
                  <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-1">
                    <p className="text-sm font-semibold text-foreground-950">
                      <span className="text-accent-400">{l.admin}</span> · {l.action}
                    </p>
                    <span className="text-xs text-foreground-600 whitespace-nowrap">{l.time}</span>
                  </div>
                  <p className="text-sm text-foreground-600 mt-0.5">{l.target}</p>
                  <p className="text-xs text-foreground-600 mt-1">IP: {l.ip}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </AdminLayout>
  );
}